module.exports = __webpack_public_path__ + "static/media/pic6.0e190d07.jpg";